import React, { PropsWithChildren, useCallback } from 'react'
import useReactRouter from 'use-react-router'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import clsx from 'clsx'
import { SidebarCustomPanePortal } from 'core/elements/header/portals'
import PassiveHeaderLink from '../passive-header-link'
import { dashboardUrl } from 'app/constants'
export interface WizardMetaProps {
  backUrl?: any
  className?: any
}

export default function WizardMeta({
  children,
  backUrl = dashboardUrl,
  className,
}: PropsWithChildren<WizardMetaProps>) {
  const classes = useStyles()
  const { history } = useReactRouter()
  const handleBackClick = useCallback(() => history.goBack(), [history])
  return (
    <SidebarCustomPanePortal>
      <div className={clsx(classes.wizardMeta, className)}>
        <PassiveHeaderLink
          icon="chevron-left"
          text="Go Back"
          onClick={handleBackClick}
          className={classes.titleLink}
        />
        {/* {icon ? <figure className={classes.wizardFigure}>{icon}</figure> : null} */}
        {children}
      </div>
    </SidebarCustomPanePortal>
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  wizardMeta: {
    padding: '20px 0px 20px 32px',
    display: 'grid',
    gridAutoRows: 'max-content',
    gridGap: 16,
  },
  titleLink: {
    marginBottom: 34,
    width: 'max-content',
    '& > *': {
      color: [theme.components.wizard.step.bubbleLabel, '!important'],
    },

    '&:hover > *': {
      color: [theme.components.wizard.step.bubbleActiveLabel, '!important'],
    },
  },
}))
